export const COMMON_STRINGS = {
  cancel: 'Cancel',
  close: 'Close',
  send: 'Send',
  newChat: 'New Chat',
};

export const MAINTENANCE_PAGE_STRINGS = {
  message1: `Oops! Minerva is taking a breather for some maintenance magic.`,
  message2: `It will be back soon!`,
};

export const ERROR_MESSAGES: { [key: string]: string } = {
  '401': 'You are not authorized. Redirecting to login screen.',
  message: 'An error occurred. Please try again.',
  queryNetworkError: 'Sorry, we cannot service you right now. Please wait and try after some time.',
  queryError: "Sorry, I don't have an answer for that. Please try another question.",
};

export const CHAT_RESPONSE_ACTIONS_TEXT: { [key: string]: string } = {
  like: 'Like',
  dislike: 'Dislike',
  review: 'Provide feedback',
  copy: 'Copy response to clipboard',
  contactUs: 'Contact Us',
  resourceCenter: 'Resource Center',
  isAnswerUseful: 'was this answer useful?',
};

export const HEADER_BAR_STRINGS = {
  waterSolution: 'Water Solutions',
  collapse: 'Collapse',
};

export const SETTINGS_STRINGS: { [key: string]: string } = {
  settingsTitle: 'Settings',
  settingsSubTitle: 'Set your preferences for data controls.',
  emailAddress: 'Email Address',
  clearAllChats: 'Clear all Chats',
  chatHistory: 'Chat History',
  settingsNote: 'Note: once turned off, chat history won’t be saved for future chats.',
  clearChatsDlgTitle: 'Are you sure you want to clear all past conversations?',
  clearChatsDlgConfirmTxt: 'Yes, Clear',
  clearChatsDlgDescription:
    'Please note that this action is irreversible. Once deleted you won’t be able to retrieve chat history.',
  clearChatSuccessMsg: 'Chat history cleared successfully.',
  historyEnabled: 'Chat history enabled successfully.',
  historydisabled: 'Chat history disabled successfully.',
};

export const ACTIVE_CHAT_SETTINGS = {
  responseCopied: 'Response copied to clipboard',
  reviewSubmitted: 'Review submitted successfully.',
  feedbackSubmitted: 'Feedback updated successfully.',
  citationsTitle: 'Below are the source citations. Select one to open.',
};

export const EDIT_TITLE_STRINGS = {
  placeholder: 'Write your chat title here',
  editBtnTooltip: 'Update',
  cancelBtnTooltip: 'Cancel',
  editTitleTooltip: 'Edit Chat Title',
  deleteChatTooltip: 'Delete Chat',
};

export const FOOTER_STRINGS = {
  promptHelpText: `Here are some examples of the types of questions I can answer:`,
  shufflePrompts: 'Shuffle the prompts',
  desclaimer: 'DISCLAIMER: ',
  desclaimerMsg: `The content in Minerva is generated by AI technology. Although we are constantly 
  working to improve the accuracy and quality of our AI-generated content, it may contain inaccuracies 
  and should not be considered as a substitute for any testing you may conduct to determine the suitability 
  of our products for your particular purpose. DuPont collects Chat data in order to improve user experience. 
  For questions regarding how DuPont protects any information you provide while using Minerva, 
  here is the link to DuPont’s Privacy Policy  `,
  readMore: 'Read More',
};

export const FOOTER_INPUT_STRINGS = {
  placholder: 'Write your query here',
  sendBtnTooltip: 'Send Query',
};

export const CHAT_HISTORY_STRINGS: { [key: string]: string } = {
  recentChats: 'Recent Chats',
  olderChats: 'Older Chats',
  chatDurationMsg: 'Chat history is available for past 6 months',
  chatTitleUpdatedMsg: 'Chat title updated successfully.',
  chatDeleteSuccessfulMessage: 'Chat history deleted successfully.',
  deleteDlgTitle: 'Are you sure you want to delete?',
  deleteDlgDesc: 'Please note that this action is irreversible. Once deleted you won’t be able to retrieve the chat.',
  deleteDlgConfirmBtn: 'Yes, Delete',
};

export const NEW_CHAT_STRINGS = {
  title: `Hi, I'm Minerva, your DuPont Water AI agent.`,
  title2: `My goal is to answer your questions about:`,
  title2info1: '- Our extensive library of technical information, such as product datasheets and technical briefs,',
  title2info2: '- Our products, technologies and innovations,',
  title2info3: '- General Information to help you solve your water and specialty processing challenges.',
  title3: `Please note that to get the best answer possible, please be as specific as possible.`,
  title4: `Let's get started! What is your question?`,
};

export const WELCOME_DIALOG_STRINGS = {
  title: 'Hi, I’m Minerva.',
  subtitle: `As DuPont Water Solutions’ AI-powered chat, I can help you find needed information about our products, 
            technologies and solutions. Before you get started, here are a few reminders: `,
  description: [
    {
      icon: 'history',
      title: 'You control your chat history.',
      label:
        'Keep your chat history for reference, delete it, or turn it off altogether (in your profile). You decide.',
    },
    {
      icon: 'privacy',
      title: 'Your chat data is safe with us.',
      label: 'I use your chat data to continuously improve, but I’ll never share it with any third parties.',
    },
    {
      icon: 'aim',
      title: 'A response may not always be 100% accurate.',
      label:
        'As I’m continuously learning (and not always 100% accurate), please consult DuPont’s experts to help finalize your solution needs.',
    },
  ],
};

export const CITATIONS_VIEWER_STRINGS = {
  pdfLoadError: 'Cannot load the document',
  openFullPDF: 'Open Full Document',
  loadingFullPDF: 'Loading Full PDF',
};

export const CHAT_REVIEW_DIALOG_STRINGS = {
  title: 'Provide Feedback',
  subtitle:
    'Assess whether the response was relevant, addressed your query correctly and if it was easy to understand.Your feedback is valuable for providing better responses in the future.',
  expectationMsg: 'On a scale from 1 to 5 (five being best), how would you rate your experience with Minerva? ',
  additionalComments: 'Additional Comments',
  inputPlaceholder: 'Add your comments here',
  ratings: [
    {
      label: '1',
      value: 1,
    },
    {
      label: '2',
      value: 2,
    },
    {
      label: '3',
      value: 3,
    },
    {
      label: '4',
      value: 4,
    },
    {
      label: '5',
      value: 5,
    },
  ],
};

export const ADMIN_PORTAL_CHAT_TABLE_STRINGS = {
  pageTitle: `Chat History Data`,
  exportTitle: 'Export Chat Data',
  downloadChat: 'Download Chat',
  exportDateRange: 'Select Date Range',
  exportColumns: 'Select Columns to Export',
  startDate: 'Start Date',
  endDate: 'End Date',
  startDateHelper: 'Minimum date: January 1, 2024',
  endDateHelper: 'Maximum date: Today',
  chatInformation: 'Chat Information',
  userFeedback: 'User Feedback',
  responseAnalysis: 'Response Analysis',
  export: 'Export',
  cancel: 'Cancel',
  selectDatesError: 'Please select both start and end dates',
  minDateError: 'Start date cannot be earlier than January 1, 2024',
  futureDateError: 'End date cannot be in the future',
  startBeforeEndError: 'Start date must be before or equal to end date',
  selectColumnsError: 'Please select at least one column to export',
  exportError: 'Failed to export data',
  exportInProgress: 'Exporting data...',
  exportSuccess: 'Data exported successfully',
  tableMsg: `To adjust accuracy or risk values, double-click on the Accuracy or Risk table cell, 
             or open the edit popup by clicking on the edit icon in each row.`,
  query: 'Query',
  response: 'Response',
  feedback: 'Feedback',
  userReview: 'User Review',
  rating: 'Rating',
  createdAt: 'Created At',
  accuracy: 'Accuracy',
  risk: 'Risk',
  comments: 'Additional Comments',
  user_email: 'User Email',
  precision_score: 'Precision Score',
  precision_rationale: 'Precision Rationale',
  relevancy_score: 'Relevancy Score',
  relevancy_rationale: 'Relevancy Rationale',
  response_completeness_score: 'Completeness Score',
  response_completeness_rationale: 'Completeness Rationale',
  overall_rating: 'Overall Rating',
  ai_metrics_group: 'AI Assisted Accuracy',
  ai_metrics_tooltip:
    'AI Assisted Metrics Explanation:\r\n\r\n' +
    '1. Precision - Measures how well the response aligns with context, avoiding fabrication and using only grounded information.\r\n\r\n' +
    "2. Response relevancy - Assesses how well the response addresses the user's query, focusing on accuracy and relevance to the question.\r\n\r\n" +
    '3. Response completeness - Evaluates how thoroughly the response covers all necessary aspects of the expected answer based on available context.\r\n\r\n' +
    '4. Overall Rating - Combined score calculated from precision, relevancy, and completeness\r\n\r\n' +
    'Rating Scale Colors:\r\n' +
    '• Orange - No related content found in the knowledge base (-1).\r\n' +
    '• Red - Poor (below 2.5)\r\n' +
    '• Yellow - Average (2.5 to 3)\r\n' +
    '• Green - Good (above 3)',
};
